/**
 * @generated SignedSource<<b0f3fd5507411fd4c665e1f81bf31d9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type DataSourceProvider = "Google" | "Office365" | "%future added value";
export type DataSourceStatus = "Okay" | "RequiresReAuth" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ChromePersonalCalendar_user$data = {
  readonly dataSources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly state: DataSourceStatus | null;
        readonly type: DataSourceProvider | null;
        readonly name: string | null;
        readonly syncTargets: ReadonlyArray<{
          readonly emailAddress: string | null;
          readonly calendarId: string | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ChromePersonalCalendar_user";
};
export type ChromePersonalCalendar_user$key = {
  readonly " $data"?: ChromePersonalCalendar_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChromePersonalCalendar_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChromePersonalCalendar_user",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000000
        }
      ],
      "concreteType": "DataSourceConnection",
      "kind": "LinkedField",
      "name": "dataSources",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DataSourceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DataSource",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CrawlTarget",
                  "kind": "LinkedField",
                  "name": "syncTargets",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "calendarId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "dataSources(first:1000000)"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "42817c71d683265aeda7cc0efcd48918";

export default node;
